export default __webpack_public_path__ + "static/media/externalLink.d887e327.svg";